import CONFIG from '../index';
export default [{
    title: '文件共享平台',
    name: 'fileShare',
    action: (_this, _router) => {
        window.open('http://top.yidianzixun.com/fileShare/login/');
    }
}, {
    title: '修改密码',
    name: 'changePwd',
    action: (_this, _router) => {
        _this.config.changePwdDialog.visible = true;
        document.onkeydown = (e) => {
            if (e.keyCode === 13) {
                _this.changePassword();
            }
        };
    }
}, {
    title: '退出',
    name: 'logout',
    action: (_this, _router) => {
        _this.$http.delete(CONFIG.HOST + '/users/loginout').then((response) => {
            let result = response.body;
            if (result && result.status === 1) {
                _router.push({
                    name: 'Login'
                });
            } else {
                _this.$notify.error({
                    message: result.message
                });
            }
        }, (response) => {
            console.log(response);
        });

    }
}];


// WEBPACK FOOTER //
// ./src/config/user_nav/index.js